const generate = (prefix) => (prefix || '') + Math.random().toString(36).slice(8);

export default {generate};
